"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.InlineNotification = void 0;
var react_1 = __importDefault(require("react"));
var GenericNotification_1 = __importDefault(require("./components/GenericNotification"));
var GenericNotification_module_scss_1 = __importDefault(require("./components/GenericNotification.module.scss"));
/**
 * {@link https://cultureamp.design/components/inline-notification/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-notification-inline-notification--default-kaizen-demo Storybook}
 */
var InlineNotification = function (_a) {
    var persistent = _a.persistent, hideCloseIcon = _a.hideCloseIcon, isSubtle = _a.isSubtle, otherProps = __rest(_a, ["persistent", "hideCloseIcon", "isSubtle"]);
    return (react_1["default"].createElement(GenericNotification_1["default"], __assign({ style: "inline", persistent: persistent || hideCloseIcon, classNameOverride: isSubtle ? GenericNotification_module_scss_1["default"].subtle : undefined }, otherProps)));
};
exports.InlineNotification = InlineNotification;
exports.InlineNotification.defaultProps = {
    autohideDelay: "short",
    autohide: false,
    hideCloseIcon: false,
    persistent: false
};
exports.InlineNotification.displayName = "InlineNotification";
//# sourceMappingURL=InlineNotification.js.map